export default __webpack_public_path__ + "static/media/wN.3ebae750.svg";